import * as React from "react";

const BOTTOM_TOLERANCE_PX = 1;

interface UseScrollToBottomOptions {
  onScrollToBottom?: () => void;
  hasMoreOptions: boolean;
  isLoadingMore: boolean;
}

function useScrollToBottom({
  onScrollToBottom,
  hasMoreOptions,
  isLoadingMore,
}: UseScrollToBottomOptions) {
  const lastScrollTopRef = React.useRef(0);

  return React.useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      if (!onScrollToBottom || !hasMoreOptions || isLoadingMore) return;

      const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
      const isScrollingDown = scrollTop > lastScrollTopRef.current;

      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      if (isScrollingDown && distanceToBottom <= BOTTOM_TOLERANCE_PX) {
        onScrollToBottom();
      }

      lastScrollTopRef.current = scrollTop;
    },
    [onScrollToBottom, hasMoreOptions, isLoadingMore]
  );
}

export { useScrollToBottom };
export type { UseScrollToBottomOptions };
